import { IHistoriaEstadoEquipoRequest } from "../../../../../Interfaces/auxiliar/IReporte"
import { ReporteService } from "../../../../../services/auxiliar/ReporteSerive"

const UseReporteExcel = (query: IHistoriaEstadoEquipoRequest) => {

    const descargarReporte = () => {
        ReporteService.ReporteExcelHistoricoEstadoEquipo(query)
            .then((res) => {
                if (res.status == 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]))
                    const link = document.createElement("a");
                    link.href = url;
                    // setLoadReporte(false)
                    link.setAttribute("download", "ReporteHistoricoEstadoEquipo.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    console.log("DESCARGA EXITOSA")
                }
            })
            .catch(e => console.log(e.message))
    }

    return { descargarReporte }
}

export { UseReporteExcel }